import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { Stack } from '@mui/system'
import { FC } from 'react'

interface PlantTableProps {
  rows: {
    id: string
    plant_description: string
    water_reference: string
    allowable_depletion: string
    refill_to: string
    root_zone: string
    plant_factor: string
  }[]
}

const PlantTable: FC<PlantTableProps> = ({ rows }) => {
  return (
    <Stack flexGrow="1">
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          backgroundColor: 'common.white',
          border: '1px solid #EFEFEF',
          borderRadius: '3px',
        }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead sx={{ backgroundColor: '#EFEFEF' }}>
            <TableRow>
              <TableCell sx={{ width: '29px' }}>#</TableCell>
              <TableCell
                sx={{
                  width: '182px',
                  borderRight: '1px solid #D7D7D7',
                }}
              >
                Plant Description
              </TableCell>
              <TableCell
                sx={{
                  width: '217px',
                }}
              >
                Water Reference
              </TableCell>
              <TableCell
                sx={{
                  width: '217px',
                }}
              >
                Allowable Depletion
              </TableCell>
              <TableCell
                sx={{
                  width: '217px',
                }}
              >
                Refill to (%)
              </TableCell>
              <TableCell
                sx={{
                  width: '217px',
                }}
              >
                Root Zone (mm)
              </TableCell>
              <TableCell
                sx={{
                  width: '217px',
                }}
              >
                Plant Factor (%)
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody sx={{ backgroundColor: 'common.white' }}>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell component="th" scope="row">
                  {row.id}
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: '1px solid #D7D7D7',
                  }}
                >
                  {row.plant_description}
                </TableCell>
                <TableCell>{row.water_reference}</TableCell>
                <TableCell>{row.allowable_depletion}</TableCell>
                <TableCell>{row.refill_to}</TableCell>
                <TableCell>{row.root_zone}</TableCell>
                <TableCell>{row.plant_factor}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  )
}

export default PlantTable
